/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Semantic key of one onboarding checklist step (fixed order 1-6). */
export enum ChecklistStepKeyEnum {
  FfScore = "ff_score",
  Notification = "notification",
  InvestAccount = "invest_account",
  BankingAccount = "banking_account",
  Tracker = "tracker",
  Goal = "goal",
}

export interface AccountReadsListResponse {
  unread_count: number;
  reads: AccountReadSummaryItem[];
}

export interface AccountReadSummaryItem {
  read_id: string;
  report_type: string;
  side: "BANKING" | "INVEST";
  headline: string;
  summary?: string;
  /** @format int64 */
  published_at: number;
  read?: boolean;
}

/** account_read.v2 — numeric values embedded in dimension objects, no metrics/meta/coverage top-level keys. */
export interface AccountReadDetailResponse {
  read_id: string;
  report_type: string;
  side: "BANKING" | "INVEST";
  headline: string;
  summary_text: string[];
  /** general_read blocks (summary-only) + dimension objects keyed by dimension name (subscriptions/idle_cash/runway/annual_bills/ sell_rule/tax_dates). Dimension presence = key existence. */
  content: object;
  /** @format int64 */
  published_at: number;
}

/** One onboarding checklist step completion state. */
export interface ChecklistStepItem {
  /**
   * Step ordinal 1-6.
   * @format int32
   */
  step_id?: number;
  /** Semantic key of one onboarding checklist step (fixed order 1-6). */
  step_key?: ChecklistStepKeyEnum;
  /** Whether the step is reached (irreversible once true). */
  completed?: boolean;
  /**
   * Completion epoch milliseconds; null when not completed.
   * @format int64
   */
  completed_at?: number | null;
}

/**
 * Onboarding checklist aggregation (flat DTO; served by the Index gateway
 * at GET /v2/api/v1/onboarding/checklist).
 */
export interface ChecklistResponse {
  /**
   * Total step count, fixed 6.
   * @format int32
   */
  total_count?: number;
  /**
   * Completed step count (0-6).
   * @format int32
   */
  completed_count?: number;
  /** Whether all 6 steps are completed. */
  all_completed?: boolean;
  /**
   * First incomplete step id (1-6); null when all completed.
   * @format int32
   */
  first_incomplete_step_id?: number | null;
  /**
   * true when all_completed and celebration not dismissed yet
   * (checklist_celebration_dismissed owner preference absent).
   */
  show_celebration?: boolean;
  /**
   * Latest financial fitness score; null before first scoring.
   * @format int32
   */
  ff_score?: number | null;
  /** The 6 step details, strictly ordered 1-6. */
  steps?: ChecklistStepItem[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://{region}-{environment}.opensocial.{domain}/v2";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Account Reads API
 * @version 2.0.0
 * @baseUrl https://{region}-{environment}.opensocial.{domain}/v2
 *
 * Account read reports. List endpoint doubles as unread badge source; detail GET is immutable and read acknowledgement is an explicit idempotent command. Watch enablement is NOT part of this API — it reuses POST /v2/trackers with displayType=financial_account_watch. Also hosts /api/v1/onboarding/checklist (Index-gateway onboarding aggregation; relocated from tracker.yaml whose /v2/tracker base 404s on that route).
 */
export class AccountReadsClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  accountReads = {
    /**
     * @description Returns reports (both sides mixed; render card variant by `side`). unread_only=true returns only unread entries. Response carries unread_count for badge usage.
     *
     * @tags accountReads
     * @name GetAccountReads
     * @summary List account read reports
     * @request GET:/account-reads
     * @secure
     */
    getAccountReads: (
      query?: {
        /** When true, return only reports with read_at IS NULL */
        unread_only?: boolean;
        /** Max entries to return (server default 20) */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccountReadsListResponse, any>({
        path: `/account-reads`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Frozen report snapshot. GET has no read-state side effect. 404 when absent.
     *
     * @tags accountReads
     * @name GetAccountReadById
     * @summary Get account read detail
     * @request GET:/account-reads/{readId}
     * @secure
     */
    getAccountReadById: (readId: string, params: RequestParams = {}) =>
      this.request<AccountReadDetailResponse, void>({
        path: `/account-reads/${readId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Explicit idempotent acknowledgement. Repeating the command is successful and never changes report content.
     *
     * @tags accountReads
     * @name MarkAccountReadRead
     * @summary Mark an account read as read
     * @request POST:/account-reads/{readId}/read
     * @secure
     */
    markAccountReadRead: (readId: string, params: RequestParams = {}) =>
      this.request<object, void>({
        path: `/account-reads/${readId}/read`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * @description Retrieve user onboarding checklist aggregation: 6 step completion states, progress counts, first incomplete step id, celebration flag and latest ff score. Owner resolved from JWT. Deployed on the Index gateway (GET /v2/api/v1/onboarding/checklist) — NOT under /v2/tracker, where the route 404s and the preflight failure surfaces as a CORS error.
     *
     * @tags Onboarding
     * @name GetChecklist
     * @summary Get setup checklist progress
     * @request GET:/api/v1/onboarding/checklist
     * @secure
     */
    getChecklist: (params: RequestParams = {}) =>
      this.request<ChecklistResponse, any>({
        path: `/api/v1/onboarding/checklist`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
